"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.jwt = void 0;
const request_1 = __importDefault(require("../request"));
exports.jwt = async function jwt(ctx, next) {
    // eslint-disable-next-line no-shadow
    const { request } = ctx;
    const jwtConfig = request.jwt;
    if (!jwtConfig) {
        await next();
        return;
    }
    const { jwtHeaderName = 'X-Jwt-Token', jwtURL = '/api/jwt', loginURL = '/api/login', jwtHeaderField = 'x-jwt-token', onJWTSuccess, validateUnauthorized = r => (r === null || r === void 0 ? void 0 : r.status) === 401, } = jwtConfig;
    if (typeof validateUnauthorized !== 'function') {
        throw 'validateUnauthorized should be a function.';
    }
    if (!this.jwt) {
        // jwt不存在时
        try {
            // 申请jwt
            let jwtRes;
            if (!this._jwtRequesting) {
                // 单例请求jwt，防止触发多次
                let _resolve = () => undefined;
                this._jwtRequesting = new Promise(resolve => (_resolve = resolve));
                jwtRes = await new request_1.default().get(jwtURL, {
                    withCredentials: true,
                    raw: true,
                });
                _resolve(jwtRes);
            }
            else {
                jwtRes = await this._jwtRequesting;
            }
            if (jwtRes && !this.jwt) {
                this.jwt = jwtRes.headers[jwtHeaderField];
                onJWTSuccess && onJWTSuccess(this.jwt);
            }
        }
        catch (error) {
            if (validateUnauthorized(error === null || error === void 0 ? void 0 : error.response)) {
                const _loginURL = typeof loginURL === 'function' ? loginURL(request, error === null || error === void 0 ? void 0 : error.response) : loginURL;
                // 未获得jwt授权，跳转至登录url
                window.location.href = _loginURL;
            }
            else {
                // 其它返回错误
                ctx.error = error;
            }
        }
    }
    request.headers = Object.assign(Object.assign({}, (request.headers || {})), { [jwtHeaderName]: this.jwt });
    await next();
};
exports.jwt.id = 'jwt';
//# sourceMappingURL=jwt.js.map